import Vue from 'vue'

export default Vue.extend({
  name: 'BackButton',

  props: {
    url: {
      type: String as Prop<string>,
      required: true
    }
  },

  methods: {
    handleClickButton () {
      this.$router.push({ path: this.url })
    }
  }
})
